import order from './order'
import setting from './setting'
import room from './room'
// import customer from './customer'

export default {
  namespaced: true, // ⚠️ 建議加上，避免命名衝突
  modules: {
    order,
    setting,
    room,
    // customer
  },
}
